module.exports = __webpack_public_path__ + "assets/media/check.f516f745.mp3";